<script lang="ts">
	export let navDestination;
	export let info;
</script>

<div class="navbar navbar-expand-lg bg-dark fixed-top" data-bs-theme="dark">
    <div class="container-fluid px-md-5 px-3">
        <a class="navbar-brand" data-sveltekit-reload href="/">
            <span class="fw-semibold fs-5 text-uppercase">Only You Bali Tours</span>
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mx-auto mb-2 mb-lg-0">
                <li class="nav-item">
                    <a class="nav-link" data-sveltekit-reload aria-current="page" href="/">Home</a>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="/" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Destinations
                    </a>
                    <ul class="dropdown-menu mt-md-3 rounded-0 border-0 pt-md-1 pt-0">
                        {#each navDestination as destination}
                        <li><a data-sveltekit-reload class="dropdown-item" href="/destination/{destination.slug}">{destination.name}</a></li>
                        {/each}
                    </ul>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-sveltekit-reload href="/package">Tour Packages</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-sveltekit-reload href="/airport-transfer">Airport Transfer</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-sveltekit-reload href="/activities">Activities</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-sveltekit-reload href="/ticket">Tickets</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-sveltekit-reload href="/about">About Us</a>
                </li>
            </ul>
            <div class="d-flex text-white flex-column fs-small">
                <div class="mb-0">
                    Got a question? Text us on Whatsapp
                </div>
                <div class="">
                    <small>
                        <a href="{info.wa}" target="_blank" class="text-decoration-none text-white">
                            <i class="ri-whatsapp-line fs-6 align-middle"></i> {info.phone}
                        </a>
                    </small>
                </div>
            </div>
        </div>
    </div>
</div>
  
<style type="text/css">
    .navbar-nav .nav-link, .navbar-nav .dropdown-item{
      color: white;
    }
    .navbar-nav .nav-link{
        font-size: 14px;
    }
    .navbar .fs-small{
        font-size: 14px;
    }
</style>